import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const ContactSection = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Get in Touch</h2>
          <p className="section-subtitle">
            Ready to Protect Your Brand? Contact Our Trademark Experts
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info-grid">
            <div className="contact-info-card">
              <div className="contact-icon">
                <MapPin size={32} />
              </div>
              <h4 className="contact-info-title">Visit Us</h4>
              <p className="contact-info-text">
                12100 Wilshire Blvd 8th floor<br />
                Los Angeles, CA 90025
              </p>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <Phone size={32} />
              </div>
              <h4 className="contact-info-title">Call Us</h4>
              <p className="contact-info-text">
                <a href="tel:+11231234567">+1 (123) 123-4567</a>
              </p>
              <p className="contact-info-subtext">Toll-Free Support</p>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <Mail size={32} />
              </div>
              <h4 className="contact-info-title">Email Us</h4>
              <p className="contact-info-text">
                <a href="mailto:info@trademarkincontext.com">info@trademarkincontext.com</a>
              </p>
              <p className="contact-info-subtext">24/7 Email Support</p>
            </div>

            <div className="contact-info-card">
              <div className="contact-icon">
                <Clock size={32} />
              </div>
              <h4 className="contact-info-title">Business Hours</h4>
              <p className="contact-info-text">
                Monday - Friday: 9am - 6pm PST<br />
                Saturday: 10am - 4pm PST
              </p>
            </div>
          </div>

          <div className="contact-map-placeholder">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.5827738!2d-118.4751!3d34.0522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDAzJzA4LjAiTiAxMTjCsDI4JzMwLjQiVw!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: "12px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Office Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
